<p-dialog [header]='setLabel("exportDataHeaderLabel")' [(visible)]="dialogVisibility" (onHide)="onBeforeDialogHide()">
    <div class="exportData">
        <button class="exportDataBtn" (click)="getAllData()" [disabled]="loading">
            {{loading ? 'Exporting data please wait....':'Export Data'}}
        </button>
    </div>
</p-dialog>